import React from 'react';
import Charts from 'components/Charts';
import { connect } from 'react-redux';
import selectors from 'store/selectors';
import { getFormValues } from 'redux-form';
import { makeStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import { getRiskToleranceRanges } from 'components/Charts/MorningstarRiskProfiler/utils';

interface Props {
  caseCustomers?: any;
  values?: any;
  userResponses?: any;
  riskSummaries: any;
  showSuitability?: boolean;
  showRisk?: boolean;
  caseInfo: any;
}

const MorningstarRiskToleranceChart: React.FC<Props> = ({
  caseCustomers,
  values,
  userResponses,
  riskSummaries,
  showSuitability = false,
  showRisk = false,
  caseInfo
}) => {
  const theme = useTheme() as any;
  const useStyles = makeStyles({
    dot: {
      display: 'inline-block',
      width: '10px',
      height: '10px',
      margin: '0 5px',
      borderRadius: '50%'
    }
  });

  const classes = useStyles();

  const isJointCustomer = !!caseCustomers.find(
    (customer: any) => customer.is_jointed
  );

  const directCustomersRiskTolerance = riskSummaries.filter(
    (riskSummary: any) => !riskSummary.customer.is_jointed
  );

  const customerOne = directCustomersRiskTolerance[0];
  const customerTwo = directCustomersRiskTolerance[1];

  let percentage = customerOne?.risk_tolerance || '-';
  let percentage_customer_2 = customerTwo?.risk_tolerance || '-';
  let suitability_score = customerOne?.recommended_risk_profile || '-';

  if (values) {
    percentage = values.risk_tolerance || '-';
    percentage_customer_2 = values.risk_tolerance_customer_2 || '-';
    suitability_score = values.recommended_risk_profile || '-';
  }

  const ranges = getRiskToleranceRanges(caseInfo.questionnaireLength);
  const calculatedGroup = ranges.find(
    range => percentage >= range.rangeStart && percentage <= range.rangeEnd
  )?.label;

  const palette = theme.palette.baseColors.charts['risk-tolerance-bar'];

  return (
    <div style={{ padding: '1rem 1rem 0' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        {showRisk && (
          <>
            <div>
              <div style={{ fontWeight: 700 }}>Risk Tolerance Group:</div>
              <div style={{ fontSize: '0.9rem' }}>{calculatedGroup}</div>
            </div>
            <div>
              <div style={{ fontWeight: 700 }}>Risk Tolerance Score:</div>
              <div
                style={{
                  display: 'flex',
                  gap: '.5rem',
                  fontSize: '0.9rem'
                }}
              >
                <div>
                  <span
                    className={classes.dot}
                    style={{
                      backgroundColor: palette[0]
                    }}
                  />
                  {percentage} ({caseCustomers?.[0]?.first_name})
                </div>
                {isJointCustomer && (
                  <div>
                    <span
                      className={classes.dot}
                      style={{
                        backgroundColor: palette[1]
                      }}
                    />
                    {percentage_customer_2} ({caseCustomers?.[1]?.first_name})
                  </div>
                )}
              </div>
              <div>(out of 100)</div>
            </div>
          </>
        )}
        <div>
          {showSuitability && (
            <>
              <div style={{ fontWeight: 700 }}>Suitability Score</div>
              <div style={{ fontSize: '0.9rem' }}>
                <span
                  className={classes.dot}
                  style={{
                    backgroundColor: palette[palette.length - 1]
                  }}
                />
                {suitability_score}
              </div>
              <div>(out of 100)</div>
            </>
          )}
        </div>
      </div>
      {showRisk && (
        <p>{userResponses?.[0]?.raw_data?.score?.riskTolerancePercentText}</p>
      )}
      <Charts.MorningstarRiskProfiler.RiskTolerance
        percentage={percentage}
        percentage_customer_2={percentage_customer_2}
        suitability_score={suitability_score}
        showSuitability={showSuitability}
        showRisk={showRisk}
      />
    </div>
  );
};

export default connect((state: any) => ({
  caseCustomers: selectors.caseSelectors.caseCustomers(state),
  values: getFormValues('riskProfile')(state),
  userResponses: selectors.questionnareSelectors.getUserResponses(state),
  riskSummaries: selectors.caseSelectors.getRiskSummary(state),
  caseInfo: selectors.caseSelectors.case(state)
}))(MorningstarRiskToleranceChart);
